import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import orderService from './orderService';
import toast from 'react-hot-toast'; // Ensure you have this installed for notifications

// Initial State
const initialState = {
    orders: [],
    adminOrders: [],
    order: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: '',
};

// Async Thunks

// Create Order
export const createOrder = createAsyncThunk(
    'orders/createOrder',
    async (cartData, thunkAPI) => {
        try {
            console.log("cartData in action:", cartData);
            const response = await orderService.createOrder(cartData);
            // toast.success('Order created successfully');
            console.log("Orders:", response);
            return response; // Assuming the API returns the created order
        } catch (error) {
            const message = error.response?.data?.message || error.message || 'Failed to create order';
            toast.error(message);
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Fetch Orders
export const fetchOrders = createAsyncThunk(
    'orders/fetchOrders',
    async (token, thunkAPI) => {
        try {
            const response = await orderService.getOrders(token);
            return response; // Assuming the API returns an array of orders
        } catch (error) {
            const message = error.response?.data?.message || error.message || 'Failed to fetch orders';
            // toast.error(message);
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Fetch Order Details
export const fetchOrderById = createAsyncThunk(
    'orders/fetchOrderById',
    async ({ orderId, token }, thunkAPI) => {
        try {
            const response = await orderService.getOrderById(orderId, token);
            return response; // Assuming the API returns the order details
        } catch (error) {
            const message = error.response?.data?.message || error.message || 'Failed to fetch order details';
            toast.error(message);
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Fetch All Orders (For Admin)
export const fetchAdminOrders = createAsyncThunk(
    'orders/fetchAdminOrders',
    async (token, thunkAPI) => {
        try {
            const response = await orderService.getAdminOrders(token);
            return response;
        } catch (error) {
            const message = error.response?.data?.message || error.message || 'Failed to fetch admin orders';
            toast.error(message);
            return thunkAPI.rejectWithValue(message);
        }
    }
);


// Slice
const orderSlice = createSlice({
    name: 'orders',
    initialState,
    reducers: {
        resetOrders: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        },
    },
    extraReducers: (builder) => {
        builder
            // Create Order
            .addCase(createOrder.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createOrder.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.order = action.payload.data; // Update the state with the newly created order
            })
            .addCase(createOrder.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })

            // Fetch Orders
            .addCase(fetchOrders.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchOrders.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.orders = action.payload.data; // Update the state with the list of orders
            })
            .addCase(fetchOrders.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })

            // Fetch Order By ID
            .addCase(fetchOrderById.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchOrderById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.order = action.payload.data; // Update the state with the order details
            })
            .addCase(fetchOrderById.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })

            // Fetch Orders (For Admin)
            .addCase(fetchAdminOrders.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAdminOrders.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.adminOrders = action.payload.orders;
            })
            .addCase(fetchAdminOrders.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    },
});

// Actions
export const { resetOrders } = orderSlice.actions;

// Reducer
export default orderSlice.reducer;
